import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, TargetIcon, UsersIcon } from 'lucide-react';
export function WhatIsForge() {
  const pillars = [{
    icon: FlameIcon,
    title: 'DISCIPLINE',
    description: 'Pressure creates diamonds. Consistency creates leverage.'
  }, {
    icon: TargetIcon,
    title: 'OWNERSHIP',
    description: 'You will not be handed results. You will be trained to earn them.'
  }, {
    icon: UsersIcon,
    title: 'LEADERSHIP',
    description: 'Leaders are not born. They are forged through action.'
  }];
  return <section id="what" className="py-32 px-6 bg-[var(--forge-charcoal)] relative" data-id="element-154">
      {/* Accent line */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[var(--forge-lava)] to-transparent" data-id="element-155" />

      <div className="max-w-6xl mx-auto" data-id="element-156">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-157">
          <h2 className="text-5xl md:text-6xl font-black tracking-tighter mb-6" data-id="element-158">
            WHAT IS <span className="text-[var(--forge-lava)]" data-id="element-159">THE FORGE</span>?
          </h2>
          <div className="max-w-3xl mx-auto space-y-6 text-lg text-[var(--forge-gray)] leading-relaxed" data-id="element-160">
            <p data-id="element-161">
              The Forge is not a job. It is not a company. It is not a program.
            </p>
            <p className="text-[var(--forge-white)] font-semibold" data-id="element-162">
              It is a high-pressure growth environment designed to turn driven
              individuals into elite performers, leaders, and operators.
            </p>
            <p data-id="element-163">
              We work inside real-world environments where discipline,
              consistency, and execution are everything.
            </p>
            <p data-id="element-164">
              You will not be given comfort.{' '}
              <span className="text-[var(--forge-lava)] font-semibold" data-id="element-165">
                You will be given opportunity.
              </span>
            </p>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-166">
          {pillars.map((pillar, index) => <motion.div key={pillar.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-[var(--forge-steel)] p-8 border border-[var(--forge-zinc)]/30 relative group" data-id="element-167">
              <div className="absolute top-0 left-0 w-full h-1 bg-[var(--forge-lava)] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-168" />

              <pillar.icon className="w-12 h-12 text-[var(--forge-lava)] mb-6" data-id="element-169" />
              <h3 className="text-2xl font-black tracking-tight mb-4" data-id="element-170">
                {pillar.title}
              </h3>
              <p className="text-[var(--forge-gray)] leading-relaxed" data-id="element-171">
                {pillar.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}